import React from 'react';
import { Animated, StyleProp, StyleSheet, View, ViewStyle } from 'react-native';
import Theme from '../../theme';

interface IProps {
  totalSteps: number;
  currentStep: number;
  style?: StyleProp<ViewStyle>;
}

export const BookingProgressBar = ({ totalSteps, currentStep, style }: IProps) => {
  return (
    <View style={[styles.container, style]}>
      {Array.from(Array(totalSteps)).map((_, index) => {
        const isLast = index === totalSteps - 1;
        const isCompleted = index < currentStep;
        return (
          <View style={[styles.progressBar, isLast && styles.noMargin]}>
            <Animated.View style={[
              StyleSheet.absoluteFill, {
                borderRadius: 2,
                width: isCompleted ? `100%` : '0%',
                backgroundColor: Theme.CHARCOAL,
              }]}>
            </Animated.View>
          </View>
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
  },
  progressBar: {
    flexDirection: 'row',
    height: 8,
    flex: 1,
    borderRadius: 2,
    marginRight: 5,
    backgroundColor: Theme.GREY_LIGHT,
  },
  noMargin: {
    marginRight: 0,
  },
});
